import cx from 'classnames';
var prefix = 'ais';

export default function classNames(block) {
  return function () {
    for (var _len = arguments.length, elements = Array(_len), _key = 0; _key < _len; _key++) {
      elements[_key] = arguments[_key];
    }

    return {
      className: cx(elements.filter(function (element) {
        return element !== undefined && element !== false;
      }).map(function (element) {
        return prefix + '-' + block + '__' + element;
      }))
    };
  };
}


// WEBPACK FOOTER //
// ../node_modules/react-instantsearch/es/src/components/classNames.js